(function() {
  'use strict';

  angular.module('ringbaPortal').directive('lightDarkThemeToggle', lightDarkThemeToggle);

  function lightDarkThemeToggle(
    userSettingsService,
    whitelabelManager,
  ) {
    'ngInject';

    const directive = {
      restrict: 'E',
      require: 'lightDarkThemeToggle',
      replace: true,
      scope: {
        isUserPreference: '<',
        isLightTheme: '<',
        onChange: '&',
        disableToggle: '<'
      },
      link: link,
      templateUrl: '/scripts/shared/directives/light-dark-theme-toggle/light-dark-theme-toggle.view.html',
      controller: 'LightDarkThemeToggleController',
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function link(scope, element, attrs, $toggleController) {
      scope.onThemeToggle = onThemeToggle;
      _setBodyClass(scope.isLightTheme);
      if ($toggleController.isUserPreference) {
        _getUserSettings();
      }

      function onThemeToggle(isLightTheme) {
        if (!scope.disableToggle) {
          $toggleController.onThemeChange(isLightTheme);
          _setBodyClass(isLightTheme);
          if (scope.onChange) {
            scope.onChange({
              isLightTheme: scope.isLightTheme
            });
          }
        }
      }

      function _getUserSettings() {
        userSettingsService.getUserSettings()
          .then(function(userSettings) {
            scope.isLightTheme = userSettings.isLightTheme;
            _setBodyClass(userSettings.isLightTheme);
          });
      }

      function _setBodyClass(isLightTheme) {
        if (isLightTheme != null) {
          whitelabelManager.applyTheme(isLightTheme, true);
        }
      }
    }
  }
})();
